import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const TABS = [["active", "Active"], ["archived", "Archived"], ["all", "All"]];

// Reusable Active / Archived / All lifecycle filter. Fetches live counts for a
// module from the shared /api/lifecycle engine. Used across every module list.
export function LifecycleTabs({ module, value, onChange, refreshKey, testidPrefix = "life-tab" }) {
  const [counts, setCounts] = useState(null);
  const loadCounts = useCallback(() => {
    if (!module) return;
    api.get(`/lifecycle/${module}`, { params: { status: "active" } })
      .then((r) => setCounts(r.data.counts)).catch(() => setCounts(null));
  }, [module]);
  useEffect(() => { loadCounts(); }, [loadCounts, refreshKey]);

  return (
    <div className="flex gap-1 bg-navy-800 border border-white/10 p-1" data-testid={`${testidPrefix}-group`}>
      {TABS.map(([k, lbl]) => (
        <button key={k} onClick={() => onChange(k)} data-testid={`${testidPrefix}-${k}`}
          className={`px-3 py-1.5 text-xs font-medium transition-colors ${value === k ? "bg-gold text-navy" : "text-gray-400 hover:text-white"}`}>
          {lbl}{counts?.[k] != null ? ` (${counts[k]})` : ""}
        </button>
      ))}
    </div>
  );
}

export default LifecycleTabs;
